/**
 * notUndefined is a helper function to convince typescript that
 * array.filter(x => notUndefined(x)) results in an Array<T> and not
 * Array<T|undefined>.
 * @param x
 */
export function notUndefined<T>(x: T | undefined): x is T {
  return x !== undefined;
}
